import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/DiseasedTreesGame/scenes/GameIntro';

interface PhaserDiseasedTreesGameProps {
    onComplete: () => void;
}

interface PhaserDiseasedTreesGameState {
}

const gameConfig: GameConfig = {
    title: "Diseased Trees Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};

class PhaserDiseasedTreesGame extends React.Component<PhaserDiseasedTreesGameProps, PhaserDiseasedTreesGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserDiseasedTreesGameProps) {
        super(props);
        bindAllOfThis(this, PhaserDiseasedTreesGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserDiseasedTreesGame;



// WEBPACK FOOTER //
// ./src/games/DiseasedTreesGame/Main.tsx